const service = {
	reloadPage: () => window.location.reload(),
	removeTokensLocalStorage: () => sessionStorage.removeItem('tokens'),
	setTokensLocalStorage: (data) => sessionStorage.setItem('tokens', JSON.stringify(data)),
	setUserLocalStorage: (data) => sessionStorage.setItem('user', JSON.stringify(data)),
	getTokensLocalStorage: () => JSON.parse(sessionStorage.getItem('tokens')),
	goToTop: ({ current: { offsetTop: top } }) => window.scrollTo({ top, behavior: 'smooth' }),
}
export default service;